<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.16667 4H17.8333C20.1667 4 22 5.83333 22 8.16667H2C2 5.83333 3.83333 4 6.16667 4ZM6.16667 19C3.83333 19 2 17.1667 2 14.8333V9.83333H22V14.8333C22 17.1667 20.1667 19 17.8333 19H6.16667ZM6.58333 15.6667C7.25 15.6667 7.83333 15.0833 7.83333 14.4167C7.83333 13.75 7.25 13.1667 6.58333 13.1667C5.91667 13.1667 5.33333 13.75 5.33333 14.4167C5.33333 15.0833 5.91667 15.6667 6.58333 15.6667Z"
      :fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup>
  interface IProps {
    currentColor?: string;
  }

  withDefaults(defineProps<IProps>(), {
    currentColor: "currentColor",
  });
</script>
